<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      qrcodeInfo: {},
    }
  },
  mounted() {
    this.qrcodeInfo = this.qs(window.location.search.slice(1));

    if(this.qrcodeInfo.bindtoken) {
      Object.keys(this.qrcodeInfo).length && this.reload();
      return;
    }

    let token = this.$route.query.token || this.qrcodeInfo.token;
    if(token) {
      localStorage.setItem('dclass_token', token)
      location.href = location.origin + location.pathname + location.hash
    }

    window.__VUE__ = true;
  },
  methods: {
    reload() {
      window.parent.wechatComponent && window.parent.wechatComponent.wechatMessage(this.qrcodeInfo);
    },
  }
}
</script>

<style lang="less">
html,
body {
  touch-action: manipulation;
}
</style>
